const baseSize = 16; // 跟postcss.config.js中rootValue的值是一致的
// 设置 rem 函数
function setRem() {
  const scale = document.documentElement.clientWidth / 1920;
  // 设置页面根节点字体大小 最高为两倍图 即设计稿为1920
  if (baseSize * Math.min(scale, 2) < 12) {
    document.documentElement.style.fontSize = '12px';
  } else {
    document.documentElement.style.fontSize = `${baseSize * Math.min(scale, 2)}px`;
  }
}

// 初始化
setRem();
window.onresize = function () {
  setRem();
};
